// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import $ from 'jquery';
import 'core-js';
import 'regenerator-runtime/runtime';
import { Menu } from "../_modules/menu/menu";

$(() => {
  new Menu();
});
